import { Switch } from '@fluentui/react-components'
import React, { useCallback, useState } from 'react'
import './RolesAssignmentComponent.scss'
import { RolesArray } from '@/util/roles'
import { RestSchemas } from '@/contexts/QueryProvider'
import clsx from 'clsx'

type MessagesProjectsMemberRolesAssignment = RestSchemas['Messages.Projects.MemberRolesAssignment']

type RolesAssignmentComponentProps = {
  title?: string
  userRoles?: MessagesProjectsMemberRolesAssignment[]
  assignedRoleIds: number[] // Parent-provided initial assigned roles
  disabledRoleIds: number[] // Parent-provided disabled roles (user doesn't have sufficient access to grant)
  onRolesChange: (assignedRoles: number[]) => void
}

export const RolesAssignmentComponent: React.FC<RolesAssignmentComponentProps> = ({
  title = 'Assign Roles',
  userRoles,
  assignedRoleIds: initialAssignedRoleIds,
  disabledRoleIds,
  onRolesChange,
}) => {
  const [assignedRoleIds, setAssignedRoleIds] = useState<number[]>(() => initialAssignedRoleIds)

  const toggleRole = useCallback(
    (roleId: number, checked: boolean) => {
      const newRoleIds = checked ? [...assignedRoleIds, roleId] : assignedRoleIds.filter((id) => id !== roleId)
      setAssignedRoleIds(newRoleIds)
      onRolesChange(newRoleIds)
    },
    [onRolesChange, assignedRoleIds]
  )

  return (
    <div className="roles-assignment-component">
      <div className="heading">{title}</div>
      <div className="switch-container">
        {(userRoles ?? RolesArray).map((role) => {
          const isChecked = assignedRoleIds.includes(role.roleId)
          //const isEnabled = roleCanBeAssigned(role.roleId, userRole)
          const isEnabled = !disabledRoleIds.includes(role.roleId)

          return (
            <Switch
              disabled={!isEnabled}
              key={role.roleId}
              label={role.roleName}
              checked={isChecked}
              onChange={(_, data) => toggleRole(role.roleId, data.checked)}
              className={clsx('!items-center', { 'switch-checked': isChecked })}
              style={{ width: 'fit-content' }}
            />
          )
        })}
      </div>
    </div>
  )
}
